import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * Extracts error message from various error types
 */
const extractErrorMessage = (
  error: FetchBaseQueryError | SerializedError | Error,
  defaultMessage: string,
): string => {
  // Handle FetchBaseQueryError (from RTK Query)
  if ('status' in error) {
    // Handle structured error data
    if ('data' in error && error.data) {
      const data = error.data as { detail?: string; message?: string };
      if (data.detail) return data.detail;
      if (data.message) return data.message;
      if (typeof data === 'string') return data;
    }
    return `Error ${error.status}: ${defaultMessage}`;
  }

  // Handle SerializedError
  if ('message' in error && error.message) {
    return error.message;
  }

  // Handle standard Error
  if (error instanceof Error) {
    return error.message;
  }

  // Fallback to default message
  return defaultMessage;
};

export default extractErrorMessage;
